export default __webpack_public_path__ + "static/media/assassinbg.90591691.jpg";